const state = {
  isActive: false
}

const mutations = {
  SEARCH_SET_IS_ACTIVE(state, isActive) {
    state.isActive = isActive
  },
}

const actions = {
  setIsActive: ({ commit }, isActive) => commit('SEARCH_SET_IS_ACTIVE', isActive),
}

const getters = {
  isActive: state => state.isActive,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
